export default "__VITE_PUBLIC_ASSET__ce1a6176__"